import React from "react";
import img1 from "../pages/Image/gorilla1.jpg";
import img2 from "../pages/Image/gorilla2.jpg";
import img3 from "../pages/Image/gorilla3.jpg";
import './destination.css'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel'; 
import Typography from '@mui/material/Typography';
import SimpleImageSlider from "react-simple-image-slider";
import Swipernew from "./Swipernew";
import slide_image_1 from '../pages/image1/IMG-20240928-WA0019.jpg';
import slide_image_2 from '../pages/image1/IMG-20240928-WA0020.jpg';
import slide_image_3 from '../pages/image1/IMG-20240928-WA0024.jpg';
import slide_image_4 from '../pages/image1/IMG-20240928-WA0025.jpg';

export default function Destination4() {

 const imageArray = [
  slide_image_1,
  slide_image_2,
  slide_image_3,
  slide_image_4,
 
];
  return (
    <>
  <div>
  <div>
            <Swipernew images={imageArray} />
        </div>
   <div className=" m-2 pt-5 ">
        <div className="container-fluid">
        <div className="ms-auto me-auto  bg2">

<h1 className="text-center name11  ">
3-Day Gorilla Flying Luxury Safari at Bwindi Impenetrable National Park
</h1>
</div>
        

          <h2>Description:</h2>
          <h3 className="ms-5 pt-3">
            
            <div>&emsp;  &emsp;This safari is best for people who have less time and wish to fly instead of travelling by road. </div>
            <div>&emsp;  &emsp;The flight takes approximately 1 hour and 30 minutes to reach at Kihihi Air strip and after landing you will be picked up by car for a short drive of less than an hour to the park. Your luxurious accommodation is collated just few minutes away from the park. Kindly note that gorilla permits are very limited, and therefore early booking is highly advised.</div>
          </h3>
        </div>
        <div className="container-fluid">
        <Box sx={{ padding: 2 }}>
      <Stepper orientation="vertical" activeStep={5}>
        {steps.map((step, index) => (
          <Step key={step.label1} color="black">
            {/* Pass label1 to StepLabel */}

            <StepLabel><h3> {step.label1}</h3></StepLabel>
            <div className=" bordernew  ">
            {/* Add the secondary label (optional, shown below the main one) */}
            <Typography variant="subtitle1" color="textblack" sx={{ ml: 2 }}>
              <h4><b>{step.label}</b></h4>
            </Typography>
            {/* Directly display the description */}
            <Typography sx={{ mt: 1, mb: 2, ml: 2 }}><h4>&emsp;{step.description}</h4></Typography></div>
          </Step>
        ))}
      </Stepper>
    </Box>
         

         

          

        
        </div>
      
      </div>
      <div class="btn-box text-white text-center">
                        <a href="https://wa.me/+971551579904" class="theme-btn btn-style-one rounded-3 m-4 ">Book Now</a>
                    </div>
   </div>


    </>
  );
}
const steps = [
  {
    label1: 'Day - 1',
    label: 'Fly to Bwindi Impenetrable National Park',
 
    description: `On this day, you will check in at Entebbe International Airport as early as 6:00 am for your departure domestic flight to Bwindi Impenetrable National Park  which will take approximately 1 and a half hours. The Flight will land at Kihihi Air strip and thereafter a short drive of less than an hour to your lodge overlooking the Bwindi Forest with a beautiful environment full of nature. The reception at the lodge will be at your service should you wish to arrange any extra activities however this will be at an extra charge.
`,
  },
  { 
    label1: 'Day - 2',
    label: 'Gorilla Tracking Experience',

    description:
      '  Today is the highlight of your trip and a dream come true. After a heavy breakfast, you will take a short drive of less than 10 minutes to the park headquarters for briefing. The briefing usually starts with a traditional dance and a general information to all the visitors. Afterwards, you will be distributed into groups of 8 people. For a better experience, your family will be in the same group. The trekking time depends on where the gorilla family allocated to you is located. The trek usually takes 4 hours or sometimes 8 hours in total. Viewing time with gorillas is strictly one hour. A face mask is a must. After the tracking, you will be returned to your lodge and relax with great memories in your mind..',
  },
  {
    label1: 'Day - 3',
    label: '   Fly Back to Entebbe International Airport',
    description: `On this last day, you will have a delicious breakfast early morning and transfer to Kihihi Airstrip for your flight to Entebbe Airport. Kindly note that the flight might have other stops before heading out to Entebbe International Airport however this will be communicated. We shall provide transportation from Entebbe airport to your hotel and back on your day of departure.`
  },
  
];
